<template>
  <div class="card text-center">
    <div class="card-body text-white" :class="flt.FlightStatus.toLowerCase()">
      <h6 class="card-title text-white mb-0"
        >{{ flt.FlightNumber }} / {{ flt.Destinations }}</h6
      >
      <small>{{ moment(flt.Ptd).format('DDMMMYY HH:mm') }}</small>
    </div>
    <div v-if="flt.FlightStatus !== 'CLOSED'" class="card-footer flt-totals">
      <div class="flt-card-footer-wrapper">
        <div>
          {{ reduceByKey(flt.PaxTotals, 'TotalRes') }}
          <small class="text-muted">Booked</small>
        </div>
        <div>
          {{ reduceByKey(flt.PaxTotals, 'TotalCkd') }}
          <small class="text-muted">Checked</small>
        </div>
        <div>
          {{
            reduceByKey(flt.PaxTotals, 'TotalRes') -
              reduceByKey(flt.PaxTotals, 'TotalCkd')
          }}
          <small class="text-muted">No Show</small>
        </div>
      </div>
      <div class="flt-card-footer-wrapper min-h-44" v-if="baggageShown">
        <div v-for="total in flt.BagTotals" :key="total.Destination">
         <div class="baggage"> {{ total.Destination }}: {{ total.TotalPieces }}/{{
            total.TotalWeight
          }} </div>
          <small class="text-muted">DSTN: PCS/WT</small>
        </div>
      </div>
    </div>
    <div v-if="flt.FlightStatus === 'CLOSED'" class="card-footer flt-totals">
      <div class="flt-card-footer-wrapper">
        <div>
          {{ reduceByKey(flt.PaxTotals, 'TotalCkd') }}
          <small class="text-muted">Checked</small>
        </div>
        <div>
          {{ reduceByKey(flt.PaxTotals, 'TotalBrd') }}
          <small class="text-muted">Boarded</small>
        </div>
        <div>
          {{
            reduceByKey(flt.PaxTotals, 'TotalCkd') -
              reduceByKey(flt.PaxTotals, 'TotalBrd')
          }}
          <small class="text-muted">Not Boarded</small>
        </div>
      </div>
       <div class="flt-card-footer-wrapper min-h-44" v-if="baggageShown">
        <div v-for="total in flt.BagTotals" :key="total.Destination">
         <div class="baggage"> {{ total.Destination }}: {{ total.TotalPieces }}/{{
            total.TotalWeight
          }} </div>
          <small class="text-muted">DSTN: PCS/WT</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'underscore'

const reduceByKey = (data, key) =>
  _.reduce(
    data,
    function(memo, obj) {
      return memo + obj[key]
    },
    0
  )

export default {
  props: {
    flt: {
      type: Object,
      required: true,
    },
    baggageShown: {
      type: Boolean,
    },
  },
  methods: {
    moment: moment,
    reduceByKey: reduceByKey,
  },
}
</script>
<style scoped>
.baggage {
    font-size: 1rem;
    margin-bottom: -4px;
}
.card-body {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0.85rem;
}
.card-footer.flt-totals {
  display: flex;
  flex-flow: column;
  padding: 0.2rem;
}
.flt-card-footer-wrapper {
  display: flex;
  justify-content: space-evenly;
}
.flt-card-footer-wrapper ~ .flt-card-footer-wrapper {
  border-top: 1px solid #d6dade;
}
.card-footer.flt-totals div {
  font-weight: 600;
  font-size: 1.15rem;
}
.card-footer.flt-totals small {
  display: block;
  font-size: 0.65rem;
}

.min-h-44 {
  min-height: 40px;
}
</style>
